<table class="table panelTracking" style="margin: 0 auto">
    <thead>
        <tr>
            <th class="infoSeguimientoFecha" style="width:15%;padding-right:5px">
                {{'Shared.Date' | translate}}
            </th>
            <th class="infoSeguimientoHora" style="width:10%;text-align: left;padding-left:15px">
                {{'Shared.Time' | translate}}
            </th>
            <th class="infoSeguimiento" style="width:54%;text-align: left;">
                {{'Shared.Status' | translate}}
            </th>
            <th class="infoSeguimientoCiudad" style="width:20%;text-align: left;">
                {{'Shared.Town' | translate}}
            </th>
        </tr>
    </thead>
    <tbody  style="position: relative;">

      <ng-scrollbar #scrollbarRef
      track="all"
      [disabled]="false"
      [autoHeightDisabled]="false"
      class="listServicepoints"
      style="position: relative">
        <tr *ngFor="let evento of tracking; let i=index">
            <td class="infoSeguimientoFecha" style="width:15%;padding-right:5px">
                {{evento.Date}}
            </td>
            <td class="infoSeguimientoHora" style="width:10%;text-align: left;padding-left:15px">
                {{evento.Time}}
            </td>
            <td class="infoSeguimiento" style="width:54%;text-align: left;" [ngStyle]="i == 0 ? {'color':'#007C39', 'font-weight':'bold'} : null">
                {{evento.Description}}
            </td>
            <td class="infoSeguimientoCiudad" style="width:20%;text-align: left;padding-left:15px">
                {{evento.Town}}
            </td>
        </tr>

      </ng-scrollbar>
    </tbody>
</table>

